import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    token:window.sessionStorage.getItem("token"),
    username:window.sessionStorage.getItem("username"),
    isLogin: window.sessionStorage.getItem("isLogin")
  },
  mutations:{
    SET_login(state, isLogin) {
      state.isLogin= isLogin
      window.sessionStorage.setItem("isLogin",isLogin)
    },
    set_username(state, username){
      state.username = username
      console.log(username)
      window.sessionStorage.setItem("username",username)
    }
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js